import { TYPE_OPTIONS_ENUM } from '../constants/observations';

export const getTypeLabel = (type) => {
  switch (type) {
    case TYPE_OPTIONS_ENUM.CALL_BACK:
      return 'Call Back';
    case TYPE_OPTIONS_ENUM.STAT:
      return 'STAT';
    case TYPE_OPTIONS_ENUM.URGENT:
      return 'Urgent';
    case TYPE_OPTIONS_ENUM.ROUTINE:
      return 'Routine';
    default:
      return '';
  }
};

export default { getTypeLabel };
